import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let desc = '';
let salidaIn = '';
let entradaIn = '';

class General extends Component {
    constructor(props){
        super(props);
        this.state = {


            notificaciones: null,
            errores: null,
            mostrar: false,
            loading: false,
            codigosInforme: [],

            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                codigo: '',
                nombreFuncionario: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
                marca1: '',
                marca2: '',
                minutos: '',
                tipoMov: '2',
                familiar: '',
                archivo: '',
                archivoFamiliar: '',
                juzgado: '',
                entrada: '',
                salida: '',
                entrada2: '',
                salida2: '',
                salidaAntHoraDesde: '',
                salidaAntHoraHasta: '',
                concepto: '',
                tipo: '',
                entradaLunes: '',
                entradaMartes: '',
                entradaMiercoles: '',
                entradaJueves: '',
                entradaViernes: '',
                entradaSabado: '',
                salidaLunes: '',
                salidaMartes: '',
                salidaMiercoles: '',
                salidaJueves: '',
                salidaViernes: '',
                salidaSabado: '',
                comentarios: '',
            },

            checkMedia: {
                media: false,
            },

            horasEntrada: [],
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarCambiosDatosArchivo = this.manejarCambiosDatosArchivo.bind(this);
        this.manejoEnvioInforme = this.manejoEnvioInforme.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
    }

    async componentDidMount(){
        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosInformesFuncionarios.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

        this.setState({
            notificaciones: null,
            errores: null,
            mostrar: false,
            loading: false,

            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                codigo: this.state.busqueda.codigo,
                nombreFuncionario: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
                minutos: '',
                marca1: '',
                marca2: '',
                tipoMov: '2',
                familiar: '',
                archivo: '',
                archivoFamiliar: '',
                juzgado: '',
                entrada: '',
                salida: '',
                entrada2: '',
                salida2: '',
                salidaAntHoraDesde: '',
                salidaAntHoraHasta: '',
                concepto: '',
                tipo: '',
                entradaLunes: '',
                entradaMartes: '',
                entradaMiercoles: '',
                entradaJueves: '',
                entradaViernes: '',
                salidaLunes: '',
                salidaMartes: '',
                salidaMiercoles: '',
                salidaJueves: '',
                salidaViernes: '',
                entradaSabado: '',
                salidaSabado: '',
                comentarios: '',
            },
        })
    }

    render(){
        return (
            <>
                {this.state.busqueda.codigo === ''
                ?
                    <Container>
                        <h3>Informes</h3>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>

                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={3}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                        <option value=''></option>
                                        {this.state.codigosInforme.map((name) => (
                                            name.idCodigosInformesFuncionarios !== 71 && name.idCodigosInformesFuncionarios !== 74  && name.idCodigosInformesFuncionarios !== 3 ?
                                            <option
                                            key={name.idCodigosInformesFuncionarios}
                                            value={name.idCodigosInformesFuncionarios}
                                            >{name.descripcion}</option>
                                            :   null
                                            ))}
                                    </select>
                                </Grid>
                            </Grid>
                        </Box>
                        <br/>
                        <br/>
                    </Container>
                :
                    null
                }
                {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '53') && (this.state.busqueda.codigo !== '80') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '62')  && (this.state.busqueda.codigo !== '74')  && (this.state.busqueda.codigo !== '73') && (this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '5') && (this.state.busqueda.codigo !== '52') && (this.state.busqueda.codigo !== '28') && (this.state.busqueda.codigo !== '46') && (this.state.busqueda.codigo !== '49') && (this.state.busqueda.codigo !== '57') && (this.state.busqueda.codigo !== '1') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '111') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '67') && (this.state.busqueda.codigo !== '71')
                ?
                    <Container>
                        <br/>
                        <br/>
                        {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '16') && (this.state.busqueda.codigo !== '17')
                        ?
                            this.state.notificaciones
                            ?
                                (<div className="alert alert-success" > {this.state.notificaciones}</div>)
                            :
                                this.state.errores
                                ?
                                    (<div className='alert alert-danger'> {this.state.errores}</div>)
                                :
                                    null
                        :
                            null
                        }
                        <br/>
                        {this.state.loading && (this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '16') && (this.state.busqueda.codigo !== '17')
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '16') && (this.state.busqueda.codigo !== '17')
                        ?
                            <form onSubmit={this.manejoEnvioInforme}>
                                <fieldset>
                                    <legend>Datos Formulario</legend>
                                    <Box sx={{ flexGrow: 1}}>
                                        {this.state.codigosInforme.map((name2) => {
                                        if(name2.idCodigosInformesFuncionarios == this.state.busqueda.codigo){
                                            desc = name2.descripcion;
                                        }
                                        })}
                                        <h4>{desc}</h4>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            {this.state.busqueda.codigo === '77' || this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42' || this.state.busqueda.codigo === '43' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '19' || this.state.busqueda.codigo === '21' || this.state.busqueda.codigo === '44' || this.state.busqueda.codigo === '51' || this.state.busqueda.codigo === '22' || this.state.busqueda.codigo === '23' || this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '47' || this.state.busqueda.codigo === '48' || this.state.busqueda.codigo === '56' || this.state.busqueda.codigo === '66'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Certificado (Imagen)</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '75'
                                            ?
                                                <Grid item xs={2}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '75'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Comprobante (Imagen)</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '10'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Constancia de Domicilio</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '10' || this.state.busqueda.codigo === '77' || this.state.busqueda.codigo === '75' || this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42' || this.state.busqueda.codigo === '43' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '19' || this.state.busqueda.codigo === '21' || this.state.busqueda.codigo === '44' || this.state.busqueda.codigo === '51' || this.state.busqueda.codigo === '22' || this.state.busqueda.codigo === '23' || this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '47' || this.state.busqueda.codigo === '48' || this.state.busqueda.codigo === '56' || this.state.busqueda.codigo === '66'
                                            ?
                                                <Grid item xs={2}>
                                                    <input type='file' id='archivo' style={{content: 'Seleccionar'}} onChange={this.manejarCambiosDatos}></input>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '10' || this.state.busqueda.codigo === '77' || this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42' || this.state.busqueda.codigo === '43' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '19' || this.state.busqueda.codigo === '21' || this.state.busqueda.codigo === '44' || this.state.busqueda.codigo === '51' || this.state.busqueda.codigo === '22' || this.state.busqueda.codigo === '23' || this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '47' || this.state.busqueda.codigo === '48' || this.state.busqueda.codigo === '56' || this.state.busqueda.codigo === '66'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Certificado De Parentesco (Imagen)</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={2}>
                                                    <input type='file' id='archivoFamiliar' onChange={this.manejarCambiosDatos}></input>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42' || this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Familiar</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42'
                                            ?
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='familiar'  value={this.state.busqueda.familiar} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>FAMILIAR</option>
                                                        <option key='1' value='HIJO'>HIJO</option>
                                                        <option key='2' value='PADRE'>PADRE</option>
                                                        <option key='3' value='MADRE'>MADRE</option>
                                                        <option key='4' value='CONYUGE'>CONYUGE</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '11'
                                            ?
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='familiar'  value={this.state.busqueda.familiar} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>FAMILIAR</option>
                                                        <option key='4' value='CONYUGE'>CONYUGE</option>
                                                        <option key='1' value='HIJO'>HIJO</option>
                                                        <option key='3' value='MADRE'>MADRE</option>
                                                        <option key='2' value='PADRE'>PADRE</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '12'
                                            ?
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='familiar'  value={this.state.busqueda.familiar} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>FAMILIAR</option>
                                                        <option key='5' value='HERMANO'>HERMANO</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='familiar'  value={this.state.busqueda.familiar} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>FAMILIAR</option>
                                                        <option key='6' value='ABUELOS'>ABUELOS</option>
                                                        <option key='7' value='NIETOS'>NIETOS</option>
                                                        <option key='8' value='PADRES, HIJOS O HERMANOS POLITICOS'>PADRES, HIJOS O HERMANOS POLITICOS</option>
                                                        <option key='9' value='PADRASTROS'>PADRASTROS</option>
                                                        <option key='10' value='HIJASTROS'>HIJASTROS</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '4' || this.state.busqueda.codigo === '42' || this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '75'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>{this.state.busqueda.codigo === '43' || this.state.busqueda.codigo === '19' || this.state.busqueda.codigo === '10' || this.state.busqueda.codigo === '21' || this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '77' ? 'Día' : 'Desde'}</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '75'
                                            ?
                                                <Grid item xs={2}>
                                                    <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '75'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '10'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Nueva Dirección</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '10'
                                            ?
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='juzgado' value={this.state.busqueda.juzgado} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '20'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Documento</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '20'
                                            ?
                                                <Grid item xs={2}>
                                                    <input type='file' id='archivo' style={{content: 'Seleccionar'}} onChange={this.manejarCambiosDatos}></input>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37'
                                            ?
                                                <Grid item xs={1.8}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '11' || this.state.busqueda.codigo === '12' || this.state.busqueda.codigo === '13'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '37'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Hasta</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '37'
                                            ?
                                                <Grid item xs={2}>
                                                    <input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='hasta' value={this.state.busqueda.hasta} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '37'
                                            ?
                                            <Grid item xs={1}>

                                            </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '14' && this.state.busqueda.codigo !== '15' && this.state.busqueda.codigo !== '37' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '4' && this.state.busqueda.codigo !== '42' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '44' && this.state.busqueda.codigo !== '51' && this.state.busqueda.codigo !== '22' && this.state.busqueda.codigo !== '23' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '11' && this.state.busqueda.codigo !== '12' && this.state.busqueda.codigo !== '13' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '47' && this.state.busqueda.codigo !== '48' && this.state.busqueda.codigo !== '56' && this.state.busqueda.codigo !== '66'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Días</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '14' && this.state.busqueda.codigo !== '15' && this.state.busqueda.codigo !== '37' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '4' && this.state.busqueda.codigo !== '42' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '44' && this.state.busqueda.codigo !== '51' && this.state.busqueda.codigo !== '22' && this.state.busqueda.codigo !== '23' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '11' && this.state.busqueda.codigo !== '12' && this.state.busqueda.codigo !== '13' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '47' && this.state.busqueda.codigo !== '48' && this.state.busqueda.codigo !== '56' && this.state.busqueda.codigo !== '66'
                                            ?  
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='dias' value={this.state.busqueda.dias} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {(this.state.busqueda.codigo === '2')
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '14' && this.state.busqueda.codigo !== '15' && this.state.busqueda.codigo !== '4' && this.state.busqueda.codigo !== '42' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '37' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '44' && this.state.busqueda.codigo !== '51' && this.state.busqueda.codigo !== '22' && this.state.busqueda.codigo !== '23' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '57' && this.state.busqueda.codigo !== '11' && this.state.busqueda.codigo !== '12' && this.state.busqueda.codigo !== '13' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '107' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '108' && this.state.busqueda.codigo !== '5' && this.state.busqueda.codigo !== '52' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '47' && this.state.busqueda.codigo !== '48' && this.state.busqueda.codigo !== '56' && this.state.busqueda.codigo !== '66'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Ejercicio (AÑO)</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo !== '77' && this.state.busqueda.codigo !== '75' && this.state.busqueda.codigo !== '14' && this.state.busqueda.codigo !== '15' && this.state.busqueda.codigo !== '4' && this.state.busqueda.codigo !== '42' && this.state.busqueda.codigo !== '43' && this.state.busqueda.codigo !== '37' && this.state.busqueda.codigo !== '19' && this.state.busqueda.codigo !== '10' && this.state.busqueda.codigo !== '21' && this.state.busqueda.codigo !== '44' && this.state.busqueda.codigo !== '51' && this.state.busqueda.codigo !== '22' && this.state.busqueda.codigo !== '23' && this.state.busqueda.codigo !== '20' && this.state.busqueda.codigo !== '57' && this.state.busqueda.codigo !== '11' && this.state.busqueda.codigo !== '12' && this.state.busqueda.codigo !== '13' && this.state.busqueda.codigo !== '35' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '107' && this.state.busqueda.codigo !== '109' && this.state.busqueda.codigo !== '108' && this.state.busqueda.codigo !== '5' && this.state.busqueda.codigo !== '52' && this.state.busqueda.codigo !== '110' && this.state.busqueda.codigo !== '47' && this.state.busqueda.codigo !== '48' && this.state.busqueda.codigo !== '56' && this.state.busqueda.codigo !== '66'
                                            ?  
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '2' && this.state.busqueda.codigo !== '106' && this.state.busqueda.codigo !== '109'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Motivo</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='juzgado' value={this.state.busqueda.juzgado} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Justificativo/Invitación</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?
                                                <Grid item xs={2}>
                                                    <input type='file' id='archivo' style={{content: 'Seleccionar'}} onChange={this.manejarCambiosDatos}></input>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '14' || this.state.busqueda.codigo === '15'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '77' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Minutos</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '77' || this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109'
                                            ?  
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='minutos' value={this.state.busqueda.minutos} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Juzgado</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35'
                                            ?  
                                                <Grid item xs={2}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='juzgado' value={this.state.busqueda.juzgado} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109' || this.state.busqueda.codigo === '77'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35'
                                            ?
                                                <Grid item xs={1.8}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '77'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Tipo Salida</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={0}>DIA COMPLETO</option>
                                                        <option value={1}>LLEGADA TARDE</option>
                                                        <option value={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '77'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>LLEGADA TARDE</option>
                                                        <option value={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '37'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>TIPO</option>
                                                    <option value={1}>Día Completo</option>
                                                    <option value={2}>Llegada Tarde</option>
                                                    <option value={3}>Salida Entre Horario</option>
                                                    <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '35' || this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '77'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '77'
                                            ?  
                                                <Grid item xs={5}>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '77'
                                            ?  
                                                <Grid item xs={2.1}>
                                                    <Item>Comentarios</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '37' || this.state.busqueda.codigo === '77'
                                            ?  
                                                    <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={40} id='comentarios' value={this.state.busqueda.comentarios} onChange={this.manejarCambiosDatos}/>

                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Entrada</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada' value={this.state.busqueda.entrada} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>ENTRADA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Salilda</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida' value={this.state.busqueda.salida} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Entrada</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada2' value={this.state.busqueda.entrada2} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>ENTRADA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '109'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Concepto</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '109'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='concepto' value={this.state.busqueda.concepto} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>CONCEPTO</option>
                                                        <option value={'1'}>LLEGADA TARDE</option>
                                                        <option value={'2'}>SALIDA ANTES DE HORA</option>
                                                        <option value={'3'}>SALIDA ENTRE HORA</option>
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?    
                                                <Grid item xs={2.1}>
                                                    <Item>Salilda</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106'
                                            ?  
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida2' value={this.state.busqueda.salida2} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '106' || this.state.busqueda.codigo === '109'
                                            ?  
                                                <Grid item xs={1}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '110'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Desde</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '110'
                                            ?
                                                <Grid item xs={3}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="time" id='salidaAntHoraDesde' value={this.state.busqueda.salidaAntHoraDesde} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '110'
                                            ?
                                                <Grid item xs={1}>

                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '110'
                                            ?
                                                <Grid item xs={2.1}>
                                                    <Item>Hasta</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '110'
                                            ?
                                                <Grid item xs={3}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} type="time" id='salidaAntHoraHasta' value={this.state.busqueda.salidaAntHoraHasta} onChange={this.manejarCambiosDatos}/>
                                                </Grid>
                                            :
                                                null
                                            }
                                        </Grid>
                                    </Box>
                                    <br/>
                                    <Box>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={4.5}>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <button className="btn btn-outline-primary" type='submit'> {this.state.modificar ? 'Modificar' : 'Confirmar'}</button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <br/>
                                </fieldset>
                            </form>
                        :
                            null
                        }
                    </Container>
                :
                    null
                }
                {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '77') && (this.state.busqueda.codigo !== '75') && (this.state.busqueda.codigo !== '74') && (this.state.busqueda.codigo !== '73') && (this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13') && (this.state.busqueda.codigo !== '4') && (this.state.busqueda.codigo !== '42') && (this.state.busqueda.codigo !== '43') && (this.state.busqueda.codigo !== '23') && (this.state.busqueda.codigo !== '19') && (this.state.busqueda.codigo !== '10') && (this.state.busqueda.codigo !== '51') && (this.state.busqueda.codigo !== '22') && (this.state.busqueda.codigo !== '47') && (this.state.busqueda.codigo !== '48') && (this.state.busqueda.codigo !== '56') && (this.state.busqueda.codigo !== '66')
                ?
                    <Container>
                        <br/>
                        {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13')
                        ?
                            this.state.notificaciones
                            ?
                                (<div className="alert alert-success" > {this.state.notificaciones}</div>)
                            :
                                this.state.errores
                                ?
                                    (<div className='alert alert-danger'> {this.state.errores}</div>)
                                : null
                        :
                            null
                        }
                        {this.state.loading && (this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13')
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13')
                        ?
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                {this.state.codigosInforme.map((name2) => {
                                if(name2.idCodigosInformesFuncionarios == this.state.busqueda.codigo){
                                    desc = name2.descripcion;
                                }
                                })}
                                <h4>{desc}</h4>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            {(this.state.busqueda.codigo === '20') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '20') || (this.state.busqueda.codigo === '60') || (this.state.busqueda.codigo === '53') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '20') || (this.state.busqueda.codigo === '62') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '5') || (this.state.busqueda.codigo === '52') ? <StyledTableCell>Asignatura</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '28') || (this.state.busqueda.codigo === '46') || (this.state.busqueda.codigo === '30') ? <StyledTableCell>Tipo Salida</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '28') && (this.state.busqueda.codigo !== '46') && (this.state.busqueda.codigo !== '111') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '67') && (this.state.busqueda.codigo !== '71') && (this.state.busqueda.codigo !== '74') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '80') && (this.state.busqueda.codigo !== '53') ? <StyledTableCell>Días</StyledTableCell> : null}
                                            {this.state.busqueda.codigo === '61' || this.state.busqueda.codigo === '62' || this.state.busqueda.codigo === '60' || this.state.busqueda.codigo === '53' ? <StyledTableCell>Fecha</StyledTableCell> : null}
                                            {this.state.busqueda.codigo === '67' ? <StyledTableCell>Lugar</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '71') ? <StyledTableCell>Entrada</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '71') ? <StyledTableCell>Salida</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '5') && (this.state.busqueda.codigo !== '52') && (this.state.busqueda.codigo !== '49') && (this.state.busqueda.codigo !== '57') && (this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '1') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '16') && (this.state.busqueda.codigo !== '17') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '67') && (this.state.busqueda.codigo !== '71') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '80') && (this.state.busqueda.codigo !== '53') ? <StyledTableCell>Minutos</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '111') ? <StyledTableCell>Día</StyledTableCell> : this.state.busqueda.codigo === '62' || this.state.busqueda.codigo === '60' || this.state.busqueda.codigo === '30' || this.state.busqueda.codigo === '53' ? null : <StyledTableCell>Desde</StyledTableCell>}
                                            {(this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '111') && ((this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '53')) ? <StyledTableCell>Hasta</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '30') ? <StyledTableCell>Día</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '110') ? <StyledTableCell>Media Hora</StyledTableCell> : null}
                                            {((this.state.busqueda.codigo === '60') && (this.state.busqueda.tipo !== '1') && (this.state.busqueda.tipo !== '')) ? <StyledTableCell>Minutos</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '61') || (this.state.busqueda.codigo === '60') ? <StyledTableCell>Comentarios</StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '2') || (this.state.busqueda.codigo === '1') ? <StyledTableCell>Ejercicio</StyledTableCell> : null}
                                            <StyledTableCell></StyledTableCell>
                                            {(this.state.busqueda.codigo === '20') || (this.state.busqueda.codigo === '110') ? <StyledTableCell></StyledTableCell> : null}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            {(this.state.busqueda.codigo === '20') || (this.state.busqueda.codigo === '53') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '20') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '20') ? <StyledTableCell></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '5') || (this.state.busqueda.codigo === '52')
                                            ?
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='juzgado' value={this.state.busqueda.juzgado} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            :
                                                null
                                            }
                                            {(this.state.busqueda.codigo === '28') || (this.state.busqueda.codigo === '46')
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={0}>DIA COMPLETO</option>
                                                        <option value={1}>LLEGADA TARDE</option>
                                                        <option value={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '60' || this.state.busqueda.codigo === '30'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''></option>
                                                        <option value={1}>Día Completo</option>
                                                        <option value={2}>Entrada Tarde</option>
                                                        <option value={3}>Salida Entre Horario</option>
                                                        <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '62'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipo'  value={this.state.busqueda.tipo} onChange={this.manejarCambiosDatos}>
                                                    <option value=''></option>
                                                        <option value={1}>ENTRADA</option>
                                                        <option value={2}>ENTRADA MEDIA HORA</option>
                                                        <option value={3}>SALIDA MEDIA HORA</option>
                                                        <option value={4}>SALIDA</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '71'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada' value={this.state.busqueda.entrada} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>ENTRADA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.busqueda.codigo === '71'
                                            ?
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida' value={this.state.busqueda.salida} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            :
                                                null
                                            }
                                            
                                            {(this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '28') && (this.state.busqueda.codigo !== '46') && (this.state.busqueda.codigo !== '111') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '67') && (this.state.busqueda.codigo !== '71') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '80') && (this.state.busqueda.codigo !== '53') ? <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='dias' value={this.state.busqueda.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null }
                                            {this.state.busqueda.codigo === '67' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='juzgado' value={this.state.busqueda.juzgado} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo !== '40') && (this.state.busqueda.codigo !== '2') && (this.state.busqueda.codigo !== '29') && (this.state.busqueda.codigo !== '5') && (this.state.busqueda.codigo !== '52') && (this.state.busqueda.codigo !== '49') && (this.state.busqueda.codigo !== '57') && (this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '1') && (this.state.busqueda.codigo !== '14') && (this.state.busqueda.codigo !== '15') && (this.state.busqueda.codigo !== '16') && (this.state.busqueda.codigo !== '17') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '67') && (this.state.busqueda.codigo !== '71') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '80') && (this.state.busqueda.codigo !== '53') ? <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='minutos' value={this.state.busqueda.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            {this.state.busqueda.codigo === '61' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca1' value={this.state.busqueda.marca1} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {this.state.busqueda.codigo === '61' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca2' value={this.state.busqueda.marca2} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '111') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '53') ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='hasta' value={this.state.busqueda.hasta} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '110') ? <StyledTableCell><FormControlLabel control={<Checkbox checked={this.state.checkMedia.media} onChange={this.cambioListadoConsulta} id='media'  inputProps={{ 'aria-label': 'controlled' }} />  }/></StyledTableCell> : null}
                                            {((this.state.busqueda.codigo === '60') && (this.state.busqueda.tipo !== '') && (this.state.busqueda.tipo !== '1')) ? <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='minutos' value={this.state.busqueda.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '61') || (this.state.busqueda.codigo === '60') ? <StyledTableCell><textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={40} id='comentarios' value={this.state.busqueda.comentarios} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '2') || (this.state.busqueda.codigo === '1') ? <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {(this.state.busqueda.codigo === '20') || (this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '111') ? <StyledTableCell></StyledTableCell> : null}
                                            <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejoEnvioInforme}>Agregar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            null
                        }
                        <br/>
                        <br/>
                    </Container>
                :
                    null
                }
                {/*-------------------*/}
                {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo === '74')
                ?
                    <Container>
                        <br/>
                        {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13')
                        ?
                            this.state.notificaciones
                            ?
                                (<div className="alert alert-success" > {this.state.notificaciones}</div>)
                            :
                                this.state.errores
                                ?
                                    (<div className='alert alert-danger'> {this.state.errores}</div>)
                                : null
                        :
                            null
                        }
                        {this.state.loading && (this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '37') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '11') && (this.state.busqueda.codigo !== '12') && (this.state.busqueda.codigo !== '13')
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        {(this.state.busqueda.codigo !== '')
                        ?
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Lunes</StyledTableCell>
                                            <StyledTableCell>Martes</StyledTableCell>
                                            <StyledTableCell>Miercoles</StyledTableCell>
                                            <StyledTableCell>Jueves</StyledTableCell>
                                            <StyledTableCell>Viernes</StyledTableCell>
                                            <StyledTableCell>Sábado</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaLunes' value={this.state.busqueda.entradaLunes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaMartes' value={this.state.busqueda.entradaMartes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaMiercoles' value={this.state.busqueda.entradaMiercoles} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaJueves' value={this.state.busqueda.entradaJueves} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaViernes' value={this.state.busqueda.entradaViernes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entradaSabado' value={this.state.busqueda.entradaSabado} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaLunes' value={this.state.busqueda.salidaLunes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaMartes' value={this.state.busqueda.salidaMartes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaMiercoles' value={this.state.busqueda.salidaMiercoles} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaJueves' value={this.state.busqueda.salidaJueves} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaViernes' value={this.state.busqueda.salidaViernes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salidaSabado' value={this.state.busqueda.salidaSabado} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>SALIDA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                                <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejoEnvioInforme}>Agregar</button>
                            </TableContainer>
                        :
                            null
                        }
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                    </Container>
                :
                    null
                }
                {/*-------------------*/}
                {(this.state.busqueda.codigo !== '') && (this.state.busqueda.codigo === '73')
                ?
                    <Container>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>

                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={3}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                        <option value=''></option>
                                        <option value={71} key={71}>CAMBIO DE HORARIO</option>
                                        <option value={74} key={74}>CAMBIO DE HORARIO FIJO SEMANAL</option>
                                    </select>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                :
                    null
                }
                {(this.state.busqueda.codigo !== '')
                ?
                    <button className="btn btn-outline-success" type='button' onClick={this.manejarVolver}>Volver</button>
                :
                    null
                }
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            loading: false,
            notificaciones: null,
        })
        const clave = e.target.id;
        if(clave === 'archivo'){
            let valor = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (e) => {
                e.preventDefault();
                this.setState(state => {
                    const numFunActualizado = state.busqueda;
                    numFunActualizado[clave] = e.target.result;
                    
                    return{
                        busqueda: numFunActualizado,
                    };
                });
            };
        }else if(clave === 'archivoFamiliar'){
            let valor = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (e) => {
                e.preventDefault();
                this.setState(state => {
                    const numFunActualizado = state.busqueda;
                    numFunActualizado[clave] = e.target.result;
                    
                    return{
                        busqueda: numFunActualizado,
                    };
                });
            };
        }else if(clave === 'codigo'){
            this.setState(state => {
                let valor = e.target.value;
                const numFunActualizado = state.busqueda;
                numFunActualizado[clave] = valor;
                numFunActualizado['archivo'] = '';
                numFunActualizado['archivoFamiliar'] = '';
                return{
                    busqueda: numFunActualizado,
                };
            });
        }else{
            let valor = e.target.value;
            this.setState({
                errores: null,
                notificaciones: null,
            });
            this.setState(state => {
                const numFunActualizado = state.busqueda;
                numFunActualizado[clave] = valor;
                numFunActualizado['codigo'] = this.state.busqueda.codigo;
                
                return{
                    busqueda: numFunActualizado,
                };
            });
        }
    }

    manejarCambiosDatosArchivo(e){
        e.preventDefault();
        let valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            this.setState({
                archivo: e.target.result,
                errores: null,
                notificaciones: null,
            })
        };
    }

    cambioListadoConsulta(e){
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'media'){

            if(valor){
                this.setState({
                    checkMedia: {
                        media: true,
                    },
                });
            }else{
                this.setState({
                    checkMedia: {
                        media: false,
                    },
                });
            }
        }
    }

    async manejoEnvioInforme(e){
        e.preventDefault();
        if((this.state.busqueda.desde === '') && ((this.state.busqueda.codigo === '43') || (this.state.busqueda.codigo === '19') || (this.state.busqueda.codigo === '10') || (this.state.busqueda.codigo === '21') || (this.state.busqueda.codigo === '106') || (this.state.busqueda.codigo === '109'))){
            this.setState({
                errores: 'DEBE INGRESAR EL DIA',
            })
        }else if((this.state.busqueda.juzgado === '') && ((this.state.busqueda.codigo === '5') || (this.state.busqueda.codigo === '52'))){
            this.setState({
                errores: 'DEBE INGRESAR LA ASIGNATURA',
            })
        }else if((this.state.busqueda.juzgado === '') && ((this.state.busqueda.codigo === '10'))){
            this.setState({
                errores: 'DEBE INGRESAR LA NUEVA DIRECCION',
            })
        }else if((this.state.busqueda.juzgado === '') && ((this.state.busqueda.codigo === '14') || (this.state.busqueda.codigo === '15'))){
            this.setState({
                errores: 'DEBE INGRESAR EL MOTIVO',
            })
        }else if((this.state.busqueda.entrada === '') && ((this.state.busqueda.codigo === '71'))){
            this.setState({
                errores: 'DEBE INGRESAR LA ENTRADA',
            })
        }else if((this.state.busqueda.salida === '') && ((this.state.busqueda.codigo === '71'))){
            this.setState({
                errores: 'DEBE INGRESAR LA SALIDA',
            })
        }else if((this.state.busqueda.desde === '') && (this.state.busqueda.codigo !== '53') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '77') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '75') && (this.state.busqueda.codigo !== '43') && (this.state.busqueda.codigo !== '19') && (this.state.busqueda.codigo !== '10') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '111')){
            this.setState({
                errores: 'DEBE INGRESAR LA FECHA DESDE',
            })
        }else if((this.state.busqueda.tipo === '') && ((this.state.busqueda.codigo === '60') || (this.state.busqueda.codigo === '30'))){
            this.setState({
                errores: 'DEBE INGRESAR EL TIPO DE SALIDA',
            })
        }else if((this.state.busqueda.desde === '') && ((this.state.busqueda.codigo === '77') || (this.state.busqueda.codigo === '60') || (this.state.busqueda.codigo === '30'))){
            this.setState({
                errores: 'DEBE INGRESAR EL DÍA',
            })
        }else if((this.state.busqueda.minutos === '') && ((this.state.busqueda.codigo === '60')) && (this.state.busqueda.tipo !== '1')){
            this.setState({
                errores: 'DEBE INGRESAR LOS MINUTOS',
            })
        }else if((this.state.busqueda.comentarios === '') && ((this.state.busqueda.codigo === '60'))){
            this.setState({
                errores: 'DEBE INGRESAR LOS COMENTARIOS',
            })
        }else if(((this.state.busqueda.codigo === '77') || (this.state.busqueda.codigo === '35') || (this.state.busqueda.codigo === '37') || (this.state.busqueda.codigo === '28') || (this.state.busqueda.codigo === '46')) && (this.state.busqueda.tipo === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL TIPO DE SALIDA',
            })
        }else if((this.state.busqueda.codigo === '20') && (this.state.busqueda.archivo === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL DOCUMENTO',
            })
        }else if((this.state.busqueda.hasta === '') && (this.state.busqueda.codigo !== '53') && (this.state.busqueda.codigo !== '30') && (this.state.busqueda.codigo !== '77') && (this.state.busqueda.codigo !== '60') && (this.state.busqueda.codigo !== '62') && (this.state.busqueda.codigo !== '75') && (this.state.busqueda.codigo !== '74') && (this.state.busqueda.codigo !== '35') && (this.state.busqueda.codigo !== '43') && (this.state.busqueda.codigo !== '19') && (this.state.busqueda.codigo !== '10') && (this.state.busqueda.codigo !== '21') && (this.state.busqueda.codigo !== '20') && (this.state.busqueda.codigo !== '106') && (this.state.busqueda.codigo !== '110') && (this.state.busqueda.codigo !== '109') && (this.state.busqueda.codigo !== '111') && (this.state.busqueda.codigo !== '61') && (this.state.busqueda.codigo !== '37')){
            this.setState({
                errores: 'DEBE INGRESAR LA FECHA HASTA',
            })
        }else if((this.state.busqueda.desde === '') && ((this.state.busqueda.codigo === '53'))){
            this.setState({
                errores: 'Debe ingresar la fecha',
            })
        }else if((this.state.busqueda.archivo === '') && ((this.state.busqueda.codigo === '77') || (this.state.busqueda.codigo === '75') || (this.state.busqueda.codigo === '14') || (this.state.busqueda.codigo === '15') || (this.state.busqueda.codigo === '4') || (this.state.busqueda.codigo === '42') || (this.state.busqueda.codigo === '43') || (this.state.busqueda.codigo === '37') || (this.state.busqueda.codigo === '19') || (this.state.busqueda.codigo === '21') || (this.state.busqueda.codigo === '44') || (this.state.busqueda.codigo === '51') || (this.state.busqueda.codigo === '22') || (this.state.busqueda.codigo === '23') || (this.state.busqueda.codigo === '11') || (this.state.busqueda.codigo === '12') || (this.state.busqueda.codigo === '13') || (this.state.busqueda.codigo === '35') || (this.state.busqueda.codigo === '47'))){
            this.setState({
                errores: 'DEBE INGRESAR EL CERTIFICADO',
            })
        }else if((this.state.busqueda.archivoFamiliar === '') && ((this.state.busqueda.codigo === '11') || (this.state.busqueda.codigo === '12') || (this.state.busqueda.codigo === '13'))){
            this.setState({
                errores: 'DEBE INGRESAR EL CERTIFICADO DE PARENTESCO',
            })
        }else if((this.state.busqueda.familiar === '') && ((this.state.busqueda.codigo === '4') || (this.state.busqueda.codigo === '42') || (this.state.busqueda.codigo === '11') || (this.state.busqueda.codigo === '12') || (this.state.busqueda.codigo === '13'))){
            this.setState({
                errores: 'DEBE INDICAR EL FAMILIAR',
            })
        }else if((this.state.busqueda.dias === '') && ((this.state.busqueda.codigo === '5') || (this.state.busqueda.codigo === '52') || (this.state.busqueda.codigo === '40') || (this.state.busqueda.codigo === '49') || (this.state.busqueda.codigo === '29') || (this.state.busqueda.codigo === '2') || (this.state.busqueda.codigo === '57') || (this.state.busqueda.codigo === '107') || (this.state.busqueda.codigo === '108') || (this.state.busqueda.codigo === '1'))){
            this.setState({
                errores: 'DEBE INDICAR LA CANTIDAD DE DIAS',
            })
        }else if((this.state.busqueda.dias === '') && ((this.state.busqueda.codigo === '17') || (this.state.busqueda.codigo === '16'))){
            this.setState({
                errores: 'DEBE INDICAR LA CANTIDAD DE DIAS',
            })
        }else if((this.state.busqueda.dias !== '') && (this.state.busqueda.dias === '0') && ((this.state.busqueda.codigo === '17') || (this.state.busqueda.codigo === '16'))){
            this.setState({
                errores: 'LA CANTIDAD DE DIAS DEBE SER MAYOR A 0',
            })
        }else if((this.state.busqueda.anio === '') && ((this.state.busqueda.codigo === '2') || (this.state.busqueda.codigo === '1'))){
            this.setState({
                errores: 'DEBE INDICAR EL AÑO DEL EJERCICIO',
            })
        }else if((this.state.busqueda.juzgado === '') && ((this.state.busqueda.codigo === '35'))){
            this.setState({
                errores: 'DEBE INDICAR EL JUZGADO',
            })
        }else if(((this.state.busqueda.minutos === '')) && ((this.state.busqueda.codigo === '77') || (this.state.busqueda.codigo === '106') || (this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '109') || (this.state.busqueda.codigo === '28') || (this.state.busqueda.codigo === '46'))){
            this.setState({
                errores: 'DEBE INDICAR LA CANTIDAD DE MINUTOS',
            })
        }else if(((this.state.busqueda.minutos === '') || (this.state.busqueda.minutos === '0')) && (this.state.busqueda.codigo === '30')){
            this.setState({
                errores: 'DEBE INDICAR LA CANTIDAD DE MINUTOS',
            })
        }else if(((this.state.busqueda.minutos === '')) && (((this.state.busqueda.codigo === '35') && (this.state.busqueda.tipo !== '0')) || ((this.state.busqueda.codigo === '37') && (this.state.busqueda.tipo !== '1')))){
            this.setState({
                errores: 'DEBE INDICAR MINUTOS',
            })
        }else if(((this.state.busqueda.minutos < 15)) && ((this.state.busqueda.codigo === '106') || (this.state.busqueda.codigo === '109'))){
            this.setState({
                errores: 'DEBE SOLICITAR AL MENOS 16 MINUTOS',
            })
        }else if((this.state.busqueda.entrada === '') && ((this.state.busqueda.codigo === '106'))){
            this.setState({
                errores: 'DEBE INDICAR LA HORA DE ENTRADA',
            })
        }else if((this.state.busqueda.salida === '') && ((this.state.busqueda.codigo === '106'))){
            this.setState({
                errores: 'DEBE INDICAR LA HORA DE SALIDA',
            })
        }else if((this.state.busqueda.salida < this.state.busqueda.entrada) && ((this.state.busqueda.codigo === '106') || (this.state.busqueda.codigo === '109'))){
            this.setState({
                errores: 'LA HORA DE SALIDA NO PUEDE SER MENOR QUE LA HORA DE ENTRADA',
            })
        }else if(((this.state.busqueda.codigo === '35') || (this.state.busqueda.codigo === '37') || (this.state.busqueda.codigo === '28') || (this.state.busqueda.codigo === '46')) && (this.state.busqueda.dias === '0') && ( this.state.busqueda.minutos === '0')){
            this.setState({
                errores: 'Los días y minutos no pueden ser los dos ceros',
            })
        }else if(((this.state.busqueda.comentarios === '') && ((this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '61')))){
            this.setState({
                errores: 'Debe ingresar un comentario',
            })
        }else if(((this.state.busqueda.desde === '') && ((this.state.busqueda.codigo === '110') || (this.state.busqueda.codigo === '61')))){
            this.setState({
                errores: 'Debe ingresar el día',
            })
        }else if((this.state.busqueda.comentarios === '') && ((this.state.busqueda.codigo === '37') || (this.state.busqueda.codigo === '77'))){
            this.setState({
                errores: 'Debe indicar un comentario',
            })
        }else if((this.state.busqueda.archivo === '') && (this.state.busqueda.codigo === '10')){
            this.setState({
                errores: 'Debe ingresar la constancia de domicilio',
            })
        }else if((this.state.busqueda.codigo === '61') && ((this.state.busqueda.marca1 === '') || (this.state.busqueda.marca2 === ''))){
            this.setState({
                errores: 'DEBE INGRESAR EL HORARIO DE SALIDA Y RETORNO',
            })
        }else{
            this.setState({
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.busqueda, 0, this.state.checkMedia]);

            const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();

            this.setState({
                errores: res,
                loading: false,
            });

            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    archivo: '',
                    archivoFamiliar: '',
                    busqueda: {
                        numeroFuncionario: sessionStorage.numeroFuncionario,
                        codigo: this.state.busqueda.codigo,
                        nombreFuncionario: sessionStorage.nombreFuncionario,
                        tipo: '',
                        ubicacionBusqueda: '',
                        ubicacionCentral: '',
                        desde: '',
                        hasta: '',
                        anio: '',
                        dias: '',
                        marca1: '',
                        marca2: '',
                        minutos: '',
                        tipoMov: '2',
                        archivo: '',
                        familiar: '',
                        archivoFamiliar: '',
                        juzgado: '',
                        entrada: '',
                        salida: '',
                        entrada2: '',
                        salida2: '',
                        salidaAntHoraDesde: '',
                        salidaAntHoraHasta: '',
                        concepto: '',
                        entradaLunes: '',
                        entradaMartes: '',
                        entradaMiercoles: '',
                        entradaJueves: '',
                        entradaViernes: '',
                        salidaLunes: '',
                        salidaMartes: '',
                        salidaMiercoles: '',
                        salidaJueves: '',
                        salidaViernes: '',
                        entradaSabado: '',
                        salidaSabado: '',
                        comentarios: '',
                    }
                });
            }
        }
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                codigo: '',
                nombreFuncionario: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
                minutos: '',
                marca1: '',
                marca2: '',
                tipoMov: '2',
                familiar: '',
                archivo: '',
                archivoFamiliar: '',
                juzgado: '',
                entrada: '',
                salida: '',
                entrada2: '',
                salida2: '',
                salidaAntHoraDesde: '',
                salidaAntHoraHasta: '',
                concepto: '',
                tipo: '',
                entradaLunes: '',
                entradaMartes: '',
                entradaMiercoles: '',
                entradaJueves: '',
                entradaViernes: '',
                salidaLunes: '',
                salidaMartes: '',
                salidaMiercoles: '',
                salidaJueves: '',
                salidaViernes: '',
                entradaSabado: '',
                salidaSabado: '',
                comentarios: '',
            },
        })
    }
}

export default General